import createTableStore from "ds/components/Table/store/useTableStore";

import { AI_TABLE_COLUMNS_CONFIG, AI_TABLE_STORAGE_KEY } from "../../constants";

const useIntegrationsAiTableStore = createTableStore({
  storageKey: AI_TABLE_STORAGE_KEY,
  config: AI_TABLE_COLUMNS_CONFIG,
});

export default useIntegrationsAiTableStore;
